export const filterLabels = {
	createdAtMin: "友だち追加日から",
	createdAtMax: "友だち追加日まで",
	memberSinceMin: "会員登録日から",
	memberSinceMax: "会員登録日まで",
	lastVisitMin: "最終来店日から",
	lastVisitMax: "最終来店日まで",
	isFriends: {
		label: "ブロック状態",
		"0": { label: "ブロックユーザーのみ", value: 0 },
		"1": { label: "ブロックユーザーを含まない", value: 1 },
	},
	isRegistered: {
		label: "会員登録状態",
		true: { label: "会員登録あり", value: true },
		false: { label: "会員登録なし", value: false },
	},
	messages: {
		label: "LINEチャット",
		unread: {
			label: "未読",
			value: "unread",
		},
		read: {
			label: "既読",
			value: "read",
		},
	},
	candidateAtMin: "候補期間（開始）",
	candidateAtMax: "候補期間（終了）",
	address: {
		label: "住所",
	},
	isCampaign: {
		label: "キャンペーン",
		true: { label: "キャンペーン対象者", value: true },
		false: { label: "キャンペーン対象外", value: false },
	},
	hasWon: {
		label: "当選状態",
		true: { label: "当選者のみ", value: true },
		false: { label: "非当選者のみ", value: false },
	},
	paymentMethod: {
		label: "決済方法",
		card: { label: "クレジットカード", value: "card" },
		on_site: { label: "注文時決済", value: "on_site" },
	},
	paymentCompletedAt: "決済完了日",
	eventCategoryId: "イベントカテゴリ",
	eventOccasionId: "イベント",
	participationStatus: {
		label: "参加状況",
		participate: { label: "参加", value: "participate" },
		reserve: { label: "予約", value: "reserve" },
		cancel: { label: "キャンセル", value: "cancel" },
	},
	occurrenceStartAt: "イベント日時（開始）",
	occurrenceEndAt: "イベント日時（終了）",
	membershipStatus: {
		label: "会員ステータス",
		provisional: { label: "仮登録", value: "provisional" },
		active: { label: "本登録", value: "active" },
		expired: { label: "期限切れ", value: "expired" },
		deactivated: { label: "退会", value: "deactivated" },
	},
};
